interface TeamMatchup {
  team: string;
  vsAt: 'vs' | '@';
  opponent: string;
}

/**
 * Type-safe parser for team matchup strings
 * @param subtitle - String in format "TEAM vs OPPONENT" or "TEAM @ OPPONENT"
 * @returns Parsed TeamMatchup or null if format is invalid
 */
export function parseTeamMatchup(subtitle: string): TeamMatchup | null {
  if (!subtitle) return null;

  const parts = subtitle.split(/\s+(vs|@)\s+/);

  // Must have exactly 3 parts: [team, vsAt, opponent]
  if (parts.length === 3 && (parts[1] === 'vs' || parts[1] === '@')) {
    return {
      team: parts[0].trim(),
      vsAt: parts[1] as 'vs' | '@',
      opponent: parts[2].trim()
    };
  }

  return null;
}